import type { LanguageCode } from "@/config/i18n";
import { defaultLanguage, isValidLanguage } from "@/config/i18n";

const LANGUAGE_PREFIX = /^\/([a-z]{2})(?=\/|$)/;

/**
 * Read the language from the first path segment, falling back to the default.
 *
 * @example getLanguageFromPathname("/ko/movies") // "ko"
 */
export function getLanguageFromPathname(
  pathname: string | null | undefined,
): LanguageCode {
  const match = pathname?.match(LANGUAGE_PREFIX);

  return match && isValidLanguage(match[1]) ? match[1] : defaultLanguage;
}

/**
 * Swap the leading language segment of a pathname.
 *
 * @example switchLanguageInPath("/en/movies/face_off", "ko") // "/ko/movies/face_off"
 */
export function switchLanguageInPath(
  pathname: string,
  lang: LanguageCode,
): string {
  if (LANGUAGE_PREFIX.test(pathname)) {
    return pathname.replace(LANGUAGE_PREFIX, `/${lang}`);
  }

  return `/${lang}${pathname === "/" ? "" : pathname}`;
}
